export default [
  {
    path: '/admin/customer-member-cards',
    name: 'customer-member-card',
    meta: { requiresAuth: true },
    component: () => import('@/pages/customer/customer-member-card')
  }
]
